import { createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { InMemoryCache, ApolloClient } from '@apollo/client';
import { useEffect, useState } from "react";
import { useMiddlewareContext } from "./middleware";

export const menus = [
    {
        id: 1,
        title: "Overview",
        path: "/",
    },
    {
        id: 2,
        title: "Enquiry Dashboard",
        path: "/enquiry",
        // children: [
        //     { id: 1, title: "profile", path: '/enquiry/details' },]
    },
    {
        id: 3,
        title: "Reports",
        path: "/reports",
        children: [
            { id: 1, title: "Enquiry", path: '/reports' },
            { id: 2, title: "Users", path: '/reports/users' }]
    },
    {
        id: 4,
        title: "Settings",
        path: "/settings",
        children: [
            { id: 1, title: "Organization", path: '/settings' },
            { id: 2, title: "Users", path: '/settings/users' },
            { id: 3, title: "Status", path: '/settings/status' },
            { id: 4, title: "Campaign", path: '/settings/campaign' },
            // { id: 4, title: "Menu", path: '/settings/menu' },
        ]
    },
    {
        id: 5,
        title: "Profile",
        path: "/profile",
    },

]
export default function useLocalStorage(key, initialValue) {
    const [value, setValue] = useState(() => {
        const jsonValue = localStorage.getItem(key)
        if (jsonValue != null) return JSON.parse(jsonValue)
        return initialValue
    })

    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(value))
    }, [key, value])

    return [value, setValue]
}


// export const usePopupModel = (setOpen) => {

//     const showModal = () => {
//         console.log('showed')
//         setOpen(true);
//     };
//     const handleOk = () => {
//         console.log('showed')
//         console.log('Clicked Save button from useModel');
//         setOpen(false);
//     };
//     const handleCancel = () => {
//         console.log('showed')
//         setOpen(false);
//     };
//     useEffect(() => {

//     }, [setOpen])

//     return { showModal, handleCancel, handleOk }
// }


